module.exports = "<div class=\"SystemAlert-wrapper SystemAlert-hidden\" ng-class=\"{'SystemAlert-visible-animation': $ctrl.systemAlerts.show, 'SystemAlert-visible': $ctrl.systemAlerts.preshow}\" ng-click=\"$ctrl.dismiss()\">\n  <div class=\"SystemAlert SystemAlert-{{$ctrl.systemAlerts.systemAlertType}}\">\n    <span><i class=\"Icon Icon-{{$ctrl.systemAlerts.systemAlertType}}\"></i></span>\n    <span class=\"SystemAlert-text\">\n      {{ $ctrl.systemAlerts.alertText }}\n    </span>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/components/system_alerts/system_alerts.html
// module id = 404
// module chunks = 24